import type { TCanvasSize } from "@/project/types";

/**
 * 세로(9:16)가 맨 앞이자 기본값입니다.
 * 릴스·쇼츠·당근에 올리는 게 대부분이라, 가로로 만들면 결국 다시 만들게 됩니다.
 */
export const DEFAULT_CANVAS_PRESETS: TCanvasSize[] = [
	{ width: 1080, height: 1920 }, // 세로 — 릴스·쇼츠
	{ width: 1080, height: 1080 }, // 정사각 — 당근·피드
	{ width: 1080, height: 1350 }, // 4:5 — 인스타 피드
	{ width: 1920, height: 1080 }, // 가로 — 유튜브
];

export const DEFAULT_CANVAS_SIZE: TCanvasSize = { width: 1080, height: 1920 };

/** 프리셋에 붙는 한글 이름. 숫자만 보면 뭐가 뭔지 모릅니다. */
export const CANVAS_PRESET_LABELS: Record<string, string> = {
	"1080x1920": "세로 · 릴스, 쇼츠",
	"1080x1080": "정사각 · 당근, 피드",
	"1080x1350": "세로 4:5 · 인스타 피드",
	"1920x1080": "가로 · 유튜브",
};

export function canvasPresetLabel(size: TCanvasSize): string {
	return CANVAS_PRESET_LABELS[`${size.width}x${size.height}`] ?? "직접 입력";
}
